// import type { ReactNode } from "react";

// export const ErrorMessage = ({ children }: { children: ReactNode }) => (
//   <p className="text-xs text-red-500">{children}</p>
// );
interface Props {
  className?: string;
  wrapperClassName?: string;
  text?: string;
}

export const ErrorMessage = ({ className = "", wrapperClassName = "", text }: Props) => {
  return (
    <div className={`flex items-center justify-center p-4 h-[250px] ${wrapperClassName}`}>
      <p className={`text-sm text-red-500 ${className}`}>{text}</p>
    </div>
  );
};
